export const servicesList = [
  {
    title: "Диспетчер",
    name: "d24",
    note: "Управление заявками",
    href: "/",
  },
  {
    title: "CRM",
    name: "acc",
    note: "Управление кабинетом жителя",
    href: `/?ref=acc`,
  },
  {
    title: "Должники",
    name: "debt",
    note: "Работа с дебиторской задолженностью",
    href: `/?ref=debt`,
  },
];